// modalNavigationStore.js
import { createSlice } from "@reduxjs/toolkit";

const modalNavigationSlice = createSlice({
  name: "modalNavigation",
  initialState: {
    history: [],
  },
  reducers: {
    pushModal: (state, action) => {
      state.history.push(action.payload);
    },
    popModal: (state) => {
      state.history.pop();
    },
    clearModalHistory: (state) => {
      state.history = [];
    },
  },
});

export const { pushModal, popModal, clearModalHistory } =
  modalNavigationSlice.actions;
export default modalNavigationSlice.reducer;
